module.exports = __webpack_public_path__ + "fonts/HELVETICA_LT_CONDENSED_LIGHT.9e53b3a5.ttf";